import { render, staticRenderFns } from "./AdminMailsPage.vue?vue&type=template&id=1af29891&scoped=true&"
import script from "./AdminMailsPage.vue?vue&type=script&lang=js&"
export * from "./AdminMailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af29891",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
